export default __webpack_public_path__ + "static/media/Facebook hover.2eba32f5.svg";